import React from 'react';

export type MobileChartCardProps = {
  title: string;
  children: React.ReactNode;
  onViewDetails?: () => void;
  containerClassName?: string;
};

const MobileChartCard: React.FC<MobileChartCardProps> = ({
  title,
  children,
  onViewDetails,
  containerClassName,
}) => {
  return (
    <div className="mobile-chart-card">
      <div className="mobile-chart-header">
        <div className="mobile-chart-title">{title}</div>

        {onViewDetails && (
          <button
            type="button"
            className="mobile-chart-action"
            onClick={onViewDetails}
          >
            View
          </button>
        )}
      </div>

      <div
        className={
          containerClassName
            ? `mobile-chart-container ${containerClassName}`
            : 'mobile-chart-container'
        }
      >
        {children}
      </div>
    </div>
  );
};

export default MobileChartCard;
